var Vendd = (function (Vendd) {
    'use strict';


    Vendd.MessageBus.subscribe(Vendd.Merchant.Messages.GetModel, Vendd.Merchant, function (envelope) {
        var reqData =
            {
                "templateCode": LhApp.Context.Item.Template,
                "configCode": "",
                "itemId": envelope.message.data.itemId

            };
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Merchant, new Vendd.Merchant.Messages.GetModelSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Merchant, new Vendd.Merchant.Messages.GetModelFailed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Merchant, new Vendd.Merchant.Messages.GetModelFailed(response));
        }
        var options = {
            method: 'POST',
            url: 'api/Merchant/GetModel',
            data: reqData,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });
        
	return Vendd;

})(Vendd || {});